<template>
  <div class="cache-setting">


    <div class="top-inputs">
      <loginInput
        :label="$t('product.cacheType')"
        :bottomTip="$t('product.cacheTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        :inputValue="cacheType"
        @changeInput="(e) => (cacheType = e)"
      />

      <div class="btn-commit" @click="commitClick">
        {{ $t("product.commit") }}
      </div>
      <loginInput
        :label="$t('product.cacheDate')"
        :bottomTip="$t('product.cacheDateTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px; margin-left: 24px"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (cacheDate = e)"
        :inputValue="cacheDate"
      />

      <div class="btn-commit" @click="commitClick2">
        {{ $t("product.commit") }}
      </div>
    </div>

    <!-- <div class="top-inputs" style="margin-top: 25px">
      <loginInput
        :label="$t('product.allRefresh')"
        :bottomTip="$t('product.cacheTip')"
        tipStyle="color: #A1A7C4;margin-left: -12px;"
        inputStyle="width: 400px; height: 40px;"
        realInputStyle="width: 400px; height: 40px;"
        @changeInput="(e) => (allRefresh = e)"
      />

      <div class="btn-commit" @click="commitClick3">
        {{ $t("product.allRefresh") }}
      </div>
    </div> -->
    <CDNSwitch
      :label="$t('product.forceCache')"
      :tipLabel="$t('product.forceCacheTip')"
      :hasbottomline="false"
      :inValue="clearPath"
      @change="switchChange"
    />

    <!-- <CDNSwitch
      :label="'流量缓冲'"
      :tipLabel="'如果出现需要持续流量请求，需要关闭流量缓冲'"
      :hasbottomline="false"
      @change="switchChange2"
    /> -->

    <div class="bottom-btn-group">
        <div class="btn-refresh" @click="allRefreshClick">{{$t('product.allRefresh')}}</div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import { configCN, productDetail } from "@/service/requestRes";
export default {
  props: {
    title: String,
    // domainHost: String,
    // serverJson: String,
    pid: Number,
  },
  data() {
    return {
      product: null,
      remap_config_json: null,
      switch: "",
      cacheType: "",
      cacheDate: "",
      clearPath: null,
      allRefresh: "",
      userSelectsOptions: [
        {
          label: "1小时",
          value: "1",
        },
        {
          label: "十年",
          value: "2",
        },
      ],
    };
  },
  mounted(){
    this.getProductDetail();
  },
  watch: {
    remap_config_json(val) {
    let serverJson1 = {};
      try {
        serverJson1 = val && JSON.parse(val);
        const { cache } = serverJson1 || {};
        const { security } = serverJson1 || {};
        this.cacheType = cache.cacheType.replace(/\\\.\(/g, '').replace(/\)\$/g,'');
        this.cacheDate = String(cache.cacheTimeout);
        this.clearPath = security.clearPath;
      } catch(e) {
        console.error(e);
      }
    }
  },
  methods: {
    getProductDetail() {
      productDetail(
          this.pid
      ).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
            this.product = data;
            this.remap_config_json = this.product.remap_config_json;
        } else {
          this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    commitClick() {
      const cacheType = {
        func: "cacheType",
        cache: {
          cacheType: this.cacheType,
        },
      };
      this.configCNMethod(cacheType);
    },

    commitClick2() {
      const cacheType = {
        func: "cacheTimeout",
        host: this.domainHost,
        cache: {
          cacheTimeout: this.cacheDate,
          useRespMaxAge: false,
        },
      };
      this.configCNMethod(cacheType);
    },

    commitClick3() {},
    allRefreshClick() {
      this.configCNMethod({func: "pureCache"});
    },
    switchChange2(e) {
      const closeBuffering = {
        func: "closeBuffering",
        host: this.domainHost,
        closeBuffering: e,
      };

      this.configCNMethod(closeBuffering);
    },
    switchChange(e) {
      const clearPath = {
        func: "clearPath",
        host: this.domainHost,
        security: {
          clearPath: e,
        },
      };

      this.configCNMethod(clearPath);
    },
    configCNMethod(obj) {
      configCN({
        ...obj,
        pid: this.product.id,
        // host: this.domainHost,
      }).then((res) => {
        const { data, code, msg } = res || {};
        if (code === 1) {
          this.$message({
            message: this.$t('common.success'),
            type: "success",
          });
        } else {
          this.$message({
            message: msg || message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.cache-setting {
  padding-top: 20px;
  padding-bottom: 120px;
  .top-inputs {
    display: flex;
    position: relative;
  }
  .bottom-btn-group {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 50px;
    .btn-refresh {
      padding: 8px 30px;
      border: 1px solid #d7dbec;
      border-radius: 4px;
      font-family: PingFangSC-Semibold;
      font-size: 14px;
      color: #5a607f;
      margin-left: 27px;
      cursor: pointer;
    }
  }
}

.btn-commit {
  padding: 0 44px;
  height: 42px;
  line-height: 42px;
  background: #d9e4ff;
  border-radius: 4px;
  font-family: PingFangSC-Semibold;
  font-size: 14px;
  color: #1e5eff;
  cursor: pointer;
  margin-top: 23px;
  margin-left: 10px;
}

.el-input__inner{
  width: 400px;
}

</style>
